export const getNextHourDate = () => {
	const today = new Date()
	today.setHours(today.getHours() + 1)

	return today
}

export const getTomorrowDate = () => {
	const today = new Date()
	const tomorrow = new Date()
	tomorrow.setDate(today.getDate() + 1)
	return tomorrow
}

export const getNextTenDaysDate = () => {
	const today = new Date()
	const nextTenDays = new Date()
	nextTenDays.setDate(today.getDate() + 10)
	return nextTenDays
}

export const getNextMonthDate = () => {
	const today = new Date()
	const nextMonth = new Date()
	nextMonth.setDate(today.getDate() + 30)
	return nextMonth
}

export const getNextYearDate = () => {
	const today = new Date()
	const nextYear = new Date()
	nextYear.setFullYear(today.getFullYear() + 1)
	return nextYear
}
